import { useState, useCallback } from 'react';
import appIcon from '../../../shared/assets/icons/liftpeak.png';
import './ComingSoonToast.css';

interface ComingSoonToastProps {
  visible: boolean;
}

export function ComingSoonToast({ visible }: ComingSoonToastProps) {
  return (
    <div className={`toast ${visible ? 'toast-visible' : ''}`}>
      <img src={appIcon} alt="" className="toast-logo" />
      <span>Coming Soon</span>
    </div>
  );
}

interface UseComingSoonToastReturn {
  showToast: boolean;
  triggerToast: () => void;
}

export function useComingSoonToast(): UseComingSoonToastReturn {
  const [showToast, setShowToast] = useState(false);

  const triggerToast = useCallback(() => {
    setShowToast(true);
    setTimeout(() => setShowToast(false), 2000);
  }, []);

  return { showToast, triggerToast };
}

export default ComingSoonToast;


